import { FormEvent, ReactNode } from 'react';

import { useBuscaAoDigitar } from 'hooks/useBuscaAoDigitar';

interface BuscaDePessoasProps {
  /** Nome acessível do campo. */
  rotulo: string;
  placeholder: string;
  /** A busca da tela: recebe o texto digitado, aparado, e mostra o resultado na própria lista. Vazio = lista completa. */
  onBuscar: (termo: string) => void;
  valorInicial?: string;
  classeDoFormulario: string;
  classeDoCampo: string;
  /** Ícone ou botão de envio antes e depois do campo, no visual de cada tela. */
  antesDoCampo?: ReactNode;
  depoisDoCampo?: ReactNode;
}

/**
 * Campo de busca de pessoas que filtra o resultado da tela enquanto se digita (AJ2-38 a AJ2-45), com a regra de
 * `useBuscaAoDigitar`: a partir de 2 letras, 300 ms depois da última tecla, chama `onBuscar` com o texto aparado. O Enter busca na hora, com
 * qualquer texto; esvaziar o campo volta à lista completa. Não há lista de sugestões. O mesmo termo não é
 * buscado duas vezes seguidas (o Enter depois da pausa, por exemplo).
 */
export default function BuscaDePessoas({
  rotulo,
  placeholder,
  onBuscar,
  valorInicial = '',
  classeDoFormulario,
  classeDoCampo,
  antesDoCampo,
  depoisDoCampo,
}: BuscaDePessoasProps) {
  // A tela recebe só o termo: as listas filtradas aqui já descartam a resposta antiga do seu jeito.
  const { texto, digitar, buscarAgora } = useBuscaAoDigitar(termo => onBuscar(termo), valorInicial);

  function enviar(evento: FormEvent) {
    evento.preventDefault();
    buscarAgora();
  }

  return (
    <form role="search" onSubmit={enviar} className={`relative ${classeDoFormulario}`}>
      {antesDoCampo}

      <input
        type="search"
        aria-label={rotulo}
        value={texto}
        onChange={evento => digitar(evento.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        className={classeDoCampo}
      />

      {depoisDoCampo}
    </form>
  );
}
